export default "__VITE_ASSET__CIdxEV0b__"